import { useState, useEffect, useRef, MutableRefObject } from 'react';

const useIsMounted = <T extends HTMLElement>() => {
  const [element, setElememt] = useState<T>();

  const parentRef = useRef<T>();

  useEffect(() => {
    setElememt(parentRef.current);
  }, []);
  return [parentRef, element] as [MutableRefObject<T>, T | undefined];
};
export default useIsMounted;
